<form *ngIf="hasLocalPassword; else localPasswordNotSet" [formGroup]="updatePasswordForm" (ngSubmit)="onUpdatePasswordSubmit()" class="change-password-form">
  <nz-form-item>
    <nz-form-label nzFor="currentPassword" [nzSpan]="6">
      {{ 'LOGIN.CURRENT_PASSWORD' | translate }}
    </nz-form-label>

    <nz-form-control [nzSpan]="18">
      <input
        nz-input
        type="password"
        formControlName="currentPassword"
        id="currentPassword"
        [class.input-invalid]="isControlInvalid('currentPassword')"
        [attr.aria-invalid]="isControlInvalid('currentPassword') ? 'true' : null"
        autocomplete="current-password"
        placeholder="{{ 'LOGIN.ENTER_CURRENT_PASSWORD' | translate }}"
      />
      <div *ngIf="isControlInvalid('currentPassword')" class="error-text">
        <div *ngIf="updatePasswordForm.get('currentPassword')?.errors?.['required']">
          {{ 'LOGIN.PASSWORD_REQUIRED' | translate }}
        </div>
        <div *ngIf="updatePasswordForm.get('currentPassword')?.errors?.['currentPasswordInvalid']">
          {{ 'LOGIN.CURRENT_PASSWORD_INVALID' | translate }}
        </div>
      </div>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item class="has-strength-meter">
    <nz-form-label nzFor="newPassword" [nzSpan]="6">
      {{ 'LOGIN.NEW_PASSWORD' | translate }}
    </nz-form-label>

    <nz-form-control [nzSpan]="18">
      <div class="input-with-icon">
        <input
          nz-input
          [type]="passwordVisible ? 'text' : 'password'"
          formControlName="newPassword"
          id="newPassword"
          [class.input-invalid]="isControlInvalid('newPassword')"
          [attr.aria-invalid]="isControlInvalid('newPassword') ? 'true' : null"
          autocomplete="new-password"
          placeholder="{{ 'LOGIN.ENTER_NEW_PASSWORD' | translate }}"
        />
        <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'" (click)="togglePasswordVisibility()"></i>
      </div>

      <!-- strength meter directly under the input -->
      <div
        class="password-strength-container"
        *ngIf="updatePasswordForm.get('newPassword')?.value && !updatePasswordForm.get('newPassword')?.errors?.['passwordTooLong']"
      >
        <div class="password-strength-meter">
          <div class="strength-bar" [ngClass]="passwordStrength"></div>
          <div class="strength-label" [ngClass]="passwordStrength">
            {{ 'SIGNUP.STRENGTH_' + passwordStrength.toUpperCase() | translate }}
          </div>
        </div>
      </div>

      <!-- errors under the meter, aligned with the input -->
      <div
        *ngIf="isControlInvalid('newPassword')"
        class="error-text"
      >
        <div *ngIf="updatePasswordForm.get('newPassword')?.errors?.['required']">
          {{ 'SIGNUP.PASSWORD_REQUIRED' | translate }}
        </div>
        <div *ngIf="updatePasswordForm.get('newPassword')?.errors?.['minlength']">
          {{ 'SIGNUP.PASSWORD_MIN_LENGTH' | translate }}
        </div>
        <div *ngIf="updatePasswordForm.get('newPassword')?.errors?.['pattern']">
          {{ 'SIGNUP.PASSWORD_COMPLEXITY' | translate }}
        </div>
        <div *ngIf="updatePasswordForm.get('newPassword')?.errors?.['passwordTooLong']">
          {{ 'SIGNUP.PASSWORD_TOO_LONG' | translate }}
        </div>
      </div>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label nzFor="confirmPassword" [nzSpan]="6">
      {{ 'LOGIN.CONFIRM_PASSWORD' | translate }}
    </nz-form-label>

    <nz-form-control [nzSpan]="18">
      <input
        nz-input
        type="password"
        formControlName="confirmPassword"
        id="confirmPassword"
        [class.input-invalid]="isConfirmPasswordInvalid()"
        [attr.aria-invalid]="isConfirmPasswordInvalid() ? 'true' : null"
        autocomplete="new-password"
        placeholder="{{ 'LOGIN.CONFIRM_NEW_PASSWORD' | translate }}"
      />
      <div *ngIf="isConfirmPasswordInvalid()" class="error-text">
        <div *ngIf="updatePasswordForm.get('confirmPassword')?.errors?.['required']">
          {{ 'LOGIN.PASSWORD_REQUIRED' | translate }}
        </div>
        <div *ngIf="updatePasswordForm.getError('mismatch') && !updatePasswordForm.get('confirmPassword')?.errors?.['required']">
          {{ 'LOGIN.PASSWORDS_DO_NOT_MATCH' | translate }}
        </div>
      </div>
    </nz-form-control>
  </nz-form-item>

  <div class="modal-actions">
    <button nz-button nzType="primary" type="submit">{{ 'LOGIN.UPDATE_PASSWORD' | translate }}</button>
  </div>
</form>

<ng-template #localPasswordNotSet>
  <p class="local-password-info">
    {{ 'ACCOUNT_SETTINGS.SECURITY.LOCAL_PASSWORD_NOT_SET' | translate }}
  </p>
</ng-template>
